/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import EnhancedTable from "components/common_components/Tables/EnhancedTable";
import Page from "components/common_components/Page/Page";
import { useDispatch } from "react-redux";
import { notifyError, notifyInfo } from "redux/actions/Notifications";
import LoadingPage from "components/common_components/LoadingPage";
import SettingsContext from "components/Settings/SettingsContext";

const headCells = [
    { index: 0, id: "groupOfPermissions", label: "Scope" },
    {
        index: 1,
        id: "name",
        label: "Permission",
        render: (_, { data }) => (
            <div className="permission">
                <b>{data.name}</b>
                <span className="id">{data.id}</span>
                <span className="description">{data.description}</span>
            </div>
        ),
    },
];

function Permissions() {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [pageableData, setPageableData] = useState(undefined);

    const { Permissions } = useContext(SettingsContext);

    function getPermissions(requestData, showLoader = true) {
        if (showLoader) {
            setIsLoading(true);
        }
        Permissions.getList({
            onSuccess: (data, pageableData) => {
                setData(data);
                setPageableData(pageableData);
                setIsLoading(false);
            },
            onInfo: (info, pageableData) => {
                dispatch(notifyInfo(info));
                setPageableData(pageableData);
                setIsLoading(false);
            },
            onError: (error) => {
                dispatch(notifyError(error));
                setIsLoading(false);
            },
            data: requestData,
        });
    }

    useEffect(() => {
        getPermissions();

        return () => {
            setData([]);
        };
    }, []);

    function filterBuilder(filterValue) {
        return filterValue
            ? {
                  id: filterValue,
                  groupOfPermissions: filterValue,
                  name: filterValue,
                  description: filterValue,
              }
            : {};
    }

    return (
        <Page className="permissions-page">
            {isLoading ? (
                <LoadingPage />
            ) : (
                <EnhancedTable
                    headCells={headCells}
                    data={data}
                    selectable={false}
                    deletable={false}
                    orderable={false}
                    keyColumnName="id"
                    onRequestData={getPermissions}
                    filterBuilder={filterBuilder}
                    pageableData={pageableData}
                    defaultRowsPerPage={10}
                />
            )}
        </Page>
    );
}

export default Permissions;
